module.exports = __webpack_public_path__ + "img/img12.ced02e72.svg";